module.exports = __webpack_public_path__ + "img/users_black.6651a52a.svg";